/**
 * Content shell for the top-level tabs. Each tab is wired, routed and
 * permission-checked; the panels are intentionally empty until we agree what
 * goes in them.
 */
export default function Placeholder({ title, blurb }: { title: string; blurb: string }) {
  return (
    <section className="panel">
      <header className="panel__head">
        <div>
          <h2>{title}</h2>
          <p className="panel__sub">{blurb}</p>
        </div>
      </header>
      <div className="empty">
        <p>Nothing here yet.</p>
        <p className="muted">This tab is a placeholder — content to be specified.</p>
      </div>
    </section>
  )
}
